import expensoImg from "../assest/images/logo.jpg";

export const Bio = {
  name: "Sapna Maurya",
  roles: ["Frontend Developer", "UI/UX Designer", "Programmer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sapnamaurya/",
  resume:
    "https://drive.google.com/file/d/1riRUarFX7Mm7MULIpsSSGvEUmak6zTvh/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/sapna-maurya-a89416251/",
  twitter: "",
  insta: "https://www.instagram.com/sapna_maurya1411/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Python (Begineer)",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thu…logo-notext.svg/1200px-Python-logo-notext.svg.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Slack",
        image:
          "https://drive.google.com/file/d/1NPhAq5H-IG4Z4W9fFDd0caW0aqz-me4J/view?usp=sharing",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Trello",
        image: "https://logotyp.us/file/trello.svg",
      },
      {
        name: "Jira",
        image: "https://www.svgrepo.com/svg/452241/jira",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.clipartmax.com/png/small/148-1481002_how-to-create-an-animated-logo-with-svg-and-css-adobe-logo.png",
    role: "Training of under Senior Software Engineer of Adobe India in Frontend Development",
    company: "Adobe",
    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Material UI",
      "JavaScript",
      "React JS",
      "Redux",
    ],
    date: "Feb 2023 - July 2023",
  },
  {
    id: 1,
    img: "https://www.clipartmax.com/png/small/148-1481002_how-to-create-an-animated-logo-with-svg-and-css-adobe-logo.png",
    role: "Part of Adobe's Sr. Software Engineer's freelance team.",
    date: "Aug 2022 - Jan 2023",

    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Material UI",
      "JavaScript",
      "React JS",
      "Redux",
    ],
  },

  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "Web Development Intern",
    company: "Code Clause Pvt. Ltd.",
    date: "June 2024 - July 2024",
    desc: "Deep dive into the world of technology & it was an opportunity to explore a wide array of technologies across different fields, tackling complex problems and finding innovative solutions. This experience sharpened my technical acumen and solidified my problem-solving skills, preparing me for a successful career in web development.",
    skills: [
      "Media Queries",
      "RESTful Services",
      "Debugging",
      "Code Optimization",
      "JavaScript",
    ],
    doc: "https://drive.google.com/file/d/1-IS-bxvaf1cddKq1BjylBbvUqT_VjOmR/view?usp=drive_link",
  },
  {
    id: 3,
    img: "https://ia902304.us.archive.org/9/items/excellence-technology-logo/Excellence%20Technology%20Logo.jpeg",
    role: "frontend Development",
    company: "Excellence Technology",
    date: "June 2024 - July 2024",
    desc: "During my tenure as a frontend Developer Intern at Excellence Technology, I spearheaded the development and honed my skills in front-end technologies. This role allowed me to deepen my expertise in React.js, along with various other programming languages, and apply my knowledge to create robust, user-centric solutions.",
    skills: ["HTML", "CSS", "Javascript ", "ReactJs", "Redux"],
  },
  {
    id: 4,
    img: "https://apptechies.com/wp-content/uploads/2025/02/512_blk_bg.png",
    role: "Apptechies ",
    date: "June 2025 - July 2025",
    desc: "During my tenure as a frontend Developer Intern at Excellence Technology, I spearheaded the development and honed my skills in front-end technologies. This role allowed me to deepen my expertise in React.js, along with various other programming languages, and apply my knowledge to create robust, user-centric solutions.",

    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Material UI",
      "JavaScript",
      "React JS",
      "Redux",
      "   Tailwind CSS",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://gndec.ac.in/sae/img/logo.png",
    school: "Guru Nanak Dev Engineering College,Ludhiana",
    date: "Aug 2022 - june 2026",
    grade: "8.24 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Guru Nanak Dev Engineering College , Ludhiana. I have completed 4 semesters and have a CGPA of 8.24. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },

  {
    id: 1,
    img: "	https://freesvg.org/storage/img/thumb/LOGO_CSG.png",
    school: "Teja Singh Sutantar Memorial Senior Secondary School,Ludhiana",
    date: "March 2021 - May 2022",
    grade: "92.4 %",
    desc: "I completed my class 12 high school education at TSSM School, Ludhiana, where I studied Science with Computer Science.",
    degree: "PSEB, Grade: 92.4 %",
  },
  {
    id: 2,
    img: "	https://freesvg.org/storage/img/thumb/LOGO_CSG.png",
    school: "Teja Singh Sutantar Memorial Senior Secondary School,Ludhiana",
    date: "March 2019 - May 2020",
    grade: "A+",
    desc: "I completed my class 10 education at TSSM School, Ludhiana .",
    degree: "PSEB, Grade: A+",
  },
];

export const projects = [
  {
    id: 0,
    title: "Guidely webpage",
    date: "Jun 2023 - July 2023",
    description:
      "Designed and developed the Guidely webpage, it is a responsive and a static webpage made by html css",
    image:
      "https://www.techmagic.co/blog/content/images/2024/02/cover-Discovery-phase-1.png",
    tags: ["HTML", "CSS"],
    category: "web app",
    github: "https://github.com/sapnamaurya/project-guidely-webspage-about-",
    webapp: "https://sapna-guidely.netlify.app/",
  },
  {
    id: 1,
    title: "Travellock",
    date: "July 2023 - Aug 2023",
    description:
      "Here I have developed a project on Tour and Travel. Online Tour and Travel Booking is a system that gives you the facility of booking any type of packages ",
    image:
      "https://imgs.search.brave.com/bkBftBxcgwHGyReWrbcIQCHyZyFjqYEe9MF_XSQc7uo/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pay5p/bWFnZWtpdC5pby90/dmxrL2Jsb2cvMjAy/NC8wOC9zTHdHMnR1/di1OZXctUHJvamVj/dC01NS5qcGc_dHI9/dy0zMjA",
    tags: ["Bootstrap"],
    category: "web app",
    github: "https://github.com/sapnamaurya/Travel-Lock",
    webapp: "https://sapna-travellock.netlify.app",
  },
  {
    id: 2,
    title: "Spotify Clone",
    date: "Aug 2023 - Oct 2023",
    description:
      "A Spotify Clone is a music streaming platform designed to replicate the features and functionalities of the popular music service, Spotify.",
    image:
      "https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/207366157979253.63836b4a95516.png",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sapnamaurya/spotify-clone",
    webapp: "https://sapna-spotify.netlify.app/",
  },

  {
    id: 3,
    title: "Calculator",
    date: "Oct 2023 - Dec 2023",
    description:
      " A calculator is typically a portable electronic device used to perform calculations, ranging from basic arithmetic to complex mathematics. Calculators are extensively used in offices, banks, shops, departmental stores & various other establishments. Scientific calculators are used by students & research workers.",
    image: "https://cdn-media-1.freecodecamp.org/images/0*7GfUdSILXBLyAbQy.png",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sapnamaurya/calculator",
    webapp: "https://sapnacalculator.netlify.app/",
  },
  {
    id: 4,
    title: "Car Animation",
    date: "Dec 2023 - Jan 2024",
    description:
      "Car animation projects involve creating realistic and engaging visual representations of vehicles, often using computer graphics and animation techniques",
    image:
      "https://storage.googleapis.com/production-thangs-public/uploads/attachments/0e1c2b0b-5064-46ea-864f-7209d5b92fbd/car%20animation.jpg",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sapnamaurya/car-aniimation",
    webapp: "https://car-ani.netlify.app",
  },
  {
    id: 5,
    title: "Tic Tac Toe",
    date: "Jan 2024 - Feb 2024",
    description:
      "Tic-tac-toe also known as noughts and crosses is a paper and pencil game for two players, whotake turns marking the spaces in a 3 x 3 grid traditionally. The player who succeeds in placingthree of their marks in a horizontal, vertical or diagonal row wins the game. It is a zero-sum ofperfect information game.",
    image:
      "https://media.geeksforgeeks.org/wp-content/cdn-uploads/implementation-tic-tac-toe.png",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sapnamaurya/tic-tac-toe",
    webapp: "https://ttc-game.netlify.app",
  },
  {
    id: 6,
    title: "Daily Karts",
    date: "Feb 2024 - Jun 2024",
    description:
      "The Amazon Clone app provides a multi-vendor eCommerce marketplace via which the vendors and the users can communicate and sell/buy products.",
    image:
      "https://mir-s3-cdn-cf.behance.net/project_modules/fs/e9e776205520805.66bc738894e65.png",
    tags: ["HTML", "CSS", "Bootstrap", "Redux", "Javascript", "React js"],
    category: "web app",
    github: "https://github.com/lets-code-vinay/io5-project-ecommerce",
    webapp: "https://dailykartss.netlify.app",
  },
  {
    id: 7,
    title: "ExpensoMeter",
    date: "Jan 2025 - May 2025",
    description:
      "Built a responsive and user-friendly interface using React.js for tracking expenses and incomes.Managed global state using React Context API to handle user authentication and UI state. Used React Router for seamless navigation across personal and business interfaces",
    image: expensoImg,
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Javascript",
      "React js",
      "Postgress",
      "Machine Learning",
    ],
    category: "web app (Team Project)",
    github: "https://github.com/sapnamaurya/Minor-Project",
    webapp: "https://github.com/sapnamaurya/Minor-Project",
  },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
  { year: 2024, text: "Worked as a freelance developer" },
];
